<gob-form-news *ngIf="newsletter"></gob-form-news>

<footer class="site-footer">
  <div class="footer-container">
    
    <section class="footer-column">
      <h2 class="footer-title">Votre compte</h2>
      <nav class="footer-links">
        <a [routerLink]="route.get('my-account')" title="Informations personnelles">Mes informations personnelles</a>
        <a [routerLink]="route.get('my-order')" title="Commandes">Mes commandes</a>
        <a [routerLink]="route.get('my-addresses')" title="Mes adresses">Mes adresses</a>
      </nav>
    </section>

    <section class="footer-column">
      <h2 class="footer-title">Service client</h2>
      <div class="footer-info">
        <p><i class="fa-regular fa-calendar-days"></i> Lundi au Vendredi</p>
        <p><i class="fa-regular fa-clock"></i> 10h - 18h</p>
        <p class="phone-number"><i class="fa-solid fa-phone"></i> 09 70 16 71 75</p>
        <a href="mailto:demandes-clients@cavernedugobelin.fr" (click)="onContactClick($event)" class="contact-link">
          <i class="fa-regular fa-envelope"></i> Contactez-nous
        </a>
      </div>
    </section>

    <section class="footer-column">
      <h2 class="footer-title">Nos plus</h2>
      <div class="footer-info highlights">
        <p><i class="fa-solid fa-truck-fast"></i> Envoi rapide</p>
        <p><i class="fa-solid fa-boxes-stacked"></i> Nombreuses références</p>
        <p><i class="fa-solid fa-shield-check"></i> Paiement sécurisé</p>
      </div>
    </section>

    <section class="footer-column">
      <h2 class="footer-title">La Caverne</h2>
      <nav class="footer-links">
        <a routerLink="/notre-univers">Qui sommes-nous</a>
        <a [routerLink]="route.get('policy')">Confidentialité</a>
        <a [routerLink]="route.get('terms')">Conditions générales</a>
        <a [routerLink]="route.get('notices')">Mentions légales</a>
      </nav>
    </section>

  </div>

  <div class="footer-divider"></div>

  <div class="footer-bottom">
    <div class="copyright">
      @2026 <strong>SARL La GobCorp</strong> - Un site de Gobelin, fait par des Gobelins.
    </div>
    
    <div class="payment-icons">
      <i class="fa-brands fa-cc-paypal"></i>
      <i class="fa-brands fa-cc-visa"></i>
      <i class="fa-brands fa-cc-mastercard"></i>
    </div>

    <div class="social-links">
      <a href="https://www.facebook.com/CavduGob/" target="_blank" class="social-icon facebook"><i class="fa-brands fa-facebook-f"></i></a>
      <a href="https://www.instagram.com/lacavernedugobelin/?hl=fr" target="_blank" class="social-icon instagram"><i class="fa-brands fa-instagram"></i></a>
      <a href="" target="_blank" class="social-icon youtube"><i class="fa-brands fa-youtube"></i></a>
    </div>
  </div>
</footer>